import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';

import * as Edge from '../../core';
import Loading from '../../components/loading';
import { AppState } from '../../store';
import { getIsNormalUser } from '../../store/permissions/selector';

export interface HomeProps {
	isLoading: boolean;
	isNormalUser: boolean;
	isGuardVision?: boolean;
}

interface HomeState {}

export class Home extends React.PureComponent<HomeProps, HomeState> {
	constructor(props: HomeProps) {
		super(props);
		this.state = {};
	}
	public render() {
		const { isLoading, isNormalUser, isGuardVision } = this.props;
		if (isLoading) {
			return <Loading />;
		}

		if (isNormalUser) {
			return <Redirect to="/dashboard" />;
		}

		return <Redirect to={isGuardVision ? '/guardvision' : '/training/evaluation'} />;
	}
}

function mapStateToProps(state: AppState) {
	const { organizationState } = state;
	return {
		isGuardVision:
			organizationState.currentOrganization &&
			organizationState.currentOrganization.organizationType &&
			organizationState.currentOrganization.organizationType.id === Edge.Models.OrganizationTypeId.GuardVision,
		...getIsNormalUser(state),
	};
}

export default connect(mapStateToProps)(Home);
